<ProgressLoader progress="{$progress}" {title} />

<script>
  import { progress } from './progress.store';
  import ProgressLoader from 'root/services/modals/ProgressLoader.notification.svelte';

  export let title = 'Please wait...';
</script>
